import { lazyImport } from '@/utils/lazyImport';
import React from 'react';
import { LoginPath } from '@/config';
const {
  Page
} = lazyImport(() => import('../index'), 'Page');
export const routes = [{
  name: '登录',
  path: LoginPath,
  element: /*#__PURE__*/React.createElement(Page, null),
  layout: 'FullPageLayout',
  enable: true
}];